import type {
  JobSalaryMarketEvaluation,
  JobSummary,
} from '@/services/jobs/model';

export function getJobSalaryMarketTextClassName(
  evaluation?: JobSalaryMarketEvaluation
): 'text-blue-50' | 'text-primary' | undefined {
  if (evaluation === 'medium') return 'text-blue-50';
  if (evaluation === 'high') return 'text-primary';
  // if (evaluation === 'nosalary') return 'text-primary';

  return undefined;
}

export function formatJobLocation(
  job: Pick<JobSummary, 'workingArrangement' | 'workingLocations'>
) {
  const location = Array.isArray(job.workingLocations)
    ? job.workingLocations.filter(Boolean).join(', ')
    : '';

  if (!location) return job.workingArrangement || 'Chưa cập nhật địa điểm';

  return job.workingArrangement
    ? `${location} (${job.workingArrangement})`
    : location;
}

export function getContentText(value?: string | string[] | null) {
  if (Array.isArray(value)) {
    return value.join('\n').trim();
  }

  return (value ?? '').trim();
}

function normalizeJobStatus(status?: string) {
  return status?.trim().toLocaleLowerCase('en-US') ?? '';
}

export function isJobExpired(job: Pick<JobSummary, 'status'>) {
  return normalizeJobStatus(job.status) === 'expired';
}

export function isJobInactive(job: Pick<JobSummary, 'status'>) {
  return normalizeJobStatus(job.status) === 'inactive';
}
